import React from 'react'
import { MOTIVOS_BLOQUEIO } from '../lib/bloqueios'

// Seletor de motivo de bloqueio: lista predefinida + "Outro" para texto livre.
// Controlado só pela string `motivo` — decide sozinho se mostra a lista ou o
// campo de texto, consoante o valor atual pertencer ou não à lista. A lista
// vem de fora (configurável por tenant em Configurações); cai para os
// motivos por omissão se o chamador não a indicar.
export default function SeletorMotivoBloqueio({ motivo, onChange, style, motivos = MOTIVOS_BLOQUEIO }) {
  const ePredefinido = motivos.includes(motivo)
  return (
    <>
      <select
        value={ePredefinido ? motivo : 'Outro'}
        onChange={e => onChange(e.target.value === 'Outro' ? '' : e.target.value)}
        style={style}
      >
        {motivos.map(m => <option key={m} value={m}>{m}</option>)}
        <option value="Outro">Outro…</option>
      </select>
      {!ePredefinido && (
        <input
          type="text"
          value={motivo}
          onChange={e => onChange(e.target.value)}
          style={{ ...style, marginTop: '8px' }}
          placeholder="Escreve o motivo"
          autoFocus
        />
      )}
    </>
  )
}
